import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@mui/material';
import MonthView from '../MonthView';
import WeekView from '../WeekView/WeekView';
import DayView from '../DayView/DayView';
const Calender = (props) => {
    const { schedule, isEditable, source, month, week, day, value, } = props;
    return (_jsxs(Box, Object.assign({ sx: { width: '100%', height: '604px' } }, { children: [value === 0 && (_jsx(DayView, { schedule: schedule, date: day, source: source, isEditable: isEditable })), value === 1 && (_jsx(WeekView, { schedule: schedule, date: week, isEditable: isEditable, source: source })), value === 2 && (_jsx(MonthView, { schedule: schedule, date: month, source: source, isEditable: isEditable }))] })));
};
export default Calender;
